/* eslint-disable react-refresh/only-export-components -- context + hook no mesmo módulo */
import type { CapitalGlobalProposalStep1FormContextValue } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form-context-value.types';
import { createContext, useContext, type ReactNode } from 'react';

export type { CapitalGlobalProposalStep1FormContextValue } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form-context-value.types';

const CapitalGlobalProposalStep1FormContext =
  createContext<CapitalGlobalProposalStep1FormContextValue | null>(null);

export function CapitalGlobalProposalStep1FormProvider({
  value,
  children,
}: {
  value: CapitalGlobalProposalStep1FormContextValue;
  children: ReactNode;
}) {
  return (
    <CapitalGlobalProposalStep1FormContext.Provider value={value}>
      {children}
    </CapitalGlobalProposalStep1FormContext.Provider>
  );
}

export function useCapitalGlobalProposalStep1Form() {
  const ctx = useContext(CapitalGlobalProposalStep1FormContext);
  if (!ctx) {
    throw new Error(
      'useCapitalGlobalProposalStep1Form must be used within CapitalGlobalProposalStep1FormProvider'
    );
  }
  return ctx;
}
